import CheckBoxField from '../../../../shared/final-form-fields/CheckBoxField';
import { useForm } from 'react-final-form';

const AutoSubmitCheckBox = props => {
  const form = useForm();

  return (
    <CheckBoxField
      {...props}
      onChange={() => form?.submit()}
      title={props?.label}
    />
  );
};

export default AutoSubmitCheckBox;
